// this is the page where the admin can see all the deliveries
// and the status of each delivery
// and the admin can change the status of each delivery
// and the admin can see the details of each delivery

import React from "react";

// components   

import CardTable from "components/Tables/CardTable.js";

export default function Deliveries() {
    return (
        <>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Deliveries"
                        route="/admin/deliveries/create"
                        columns={[
                            { label: "Delivery ID", key: "delivery_id", render: (value) => <b>{value}</b> },
                            { label: "Order ID", key: "order_id" },
                            { label: "Product", key: "product" },
                            { label: "Quantity", key: "quantity" },
                            { label: "Status", key: "status" },
                            { label: "Delivery Method", key: "delivery_method" },
                            { label: "Tracking Number", key: "tracking_number" },
                            { label: "Delivered At", key: "delivered_at", render: (value) => <span>{new Date(value).toLocaleString()}</span> },
                        ]}
                        data={[
                            {
                                delivery_id: "DEL12345",
                                order_id: "ORD56789",
                                product: "Grocery Basket",
                                quantity: 10,
                                status: "Shipped",
                                delivery_method: "Courier",
                                tracking_number: "TRACK98765",
                                delivered_at: "2024-11-28T10:00:00Z",
                            },
                            {
                                delivery_id: "DEL12346",
                                order_id: "ORD56790",
                                product: "Organic Vegetables",
                                quantity: 5,
                                status: "Delivered",
                                delivery_method: "In-store Pickup",
                                tracking_number: "TRACK98766",
                                delivered_at: "2024-11-27T14:30:00Z",
                            },
                            {
                                delivery_id: "DEL12347",
                                order_id: "ORD56791",
                                product: "Packaged Meat",
                                quantity: 3,
                                status: "Out for Delivery",
                                delivery_method: "Courier",
                                tracking_number: "TRACK98767",
                                delivered_at: "2024-11-29T08:15:00Z",
                            },
                            {
                                delivery_id: "DEL12348",
                                order_id: "ORD56792",
                                product: "Fresh Fruits",
                                quantity: 15,
                                status: "Shipped",
                                delivery_method: "Courier",
                                tracking_number: "TRACK98768",
                                delivered_at: "2024-11-28T16:45:00Z",
                            },
                            {
                                delivery_id: "DEL12349",
                                order_id: "ORD56793",
                                product: "Dairy Products",
                                quantity: 8,
                                status: "Delivered",
                                delivery_method: "In-store Pickup",
                                tracking_number: "TRACK98769",
                                delivered_at: "2024-11-26T12:00:00Z",
                            },
                            {
                                delivery_id: "DEL12350",
                                order_id: "ORD56794",
                                product: "Bread & Bakery Items",
                                quantity: 20,
                                status: "Out for Delivery",
                                delivery_method: "Courier",
                                tracking_number: "TRACK98770",
                                delivered_at: "2024-11-29T10:30:00Z",
                            },
                        ]}
                    />

                </div>
            </div>
        </>
    );
}